/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationEventTooltipsResident } from './IntegrationEventTooltipsResident';
import {
    IntegrationEventTooltipsResidentFromJSON,
    IntegrationEventTooltipsResidentFromJSONTyped,
    IntegrationEventTooltipsResidentToJSON,
    IntegrationEventTooltipsResidentToJSONTyped,
} from './IntegrationEventTooltipsResident';
import type { IntegrationEventTooltipsActions } from './IntegrationEventTooltipsActions';
import {
    IntegrationEventTooltipsActionsFromJSON,
    IntegrationEventTooltipsActionsFromJSONTyped,
    IntegrationEventTooltipsActionsToJSON,
    IntegrationEventTooltipsActionsToJSONTyped,
} from './IntegrationEventTooltipsActions';

/**
 * 
 * @export
 * @interface IntegrationEventTooltips
 */
export interface IntegrationEventTooltips {
    /**
     * 
     */
    actions?: IntegrationEventTooltipsActions;
    /**
     * 
     */
    resident?: IntegrationEventTooltipsResident;
    /**
     * 
     */
    pcc_update?: IntegrationEventTooltipsResident;
}

/**
 * Check if a given object implements the IntegrationEventTooltips interface.
 */
export function instanceOfIntegrationEventTooltips(value: object): value is IntegrationEventTooltips {
    return true;
}

export function IntegrationEventTooltipsFromJSON(json: any): IntegrationEventTooltips {
    return IntegrationEventTooltipsFromJSONTyped(json, false);
}

export function IntegrationEventTooltipsFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventTooltips {
    if (json == null) {
        return json;
    }
    return {
        
        'actions': json['actions'] == null ? undefined : IntegrationEventTooltipsActionsFromJSON(json['actions']),
        'resident': json['resident'] == null ? undefined : IntegrationEventTooltipsResidentFromJSON(json['resident']),
        'pcc_update': json['pcc_update'] == null ? undefined : IntegrationEventTooltipsResidentFromJSON(json['pcc_update']),
    };
}

export function IntegrationEventTooltipsToJSON(json: any): IntegrationEventTooltips {
    return IntegrationEventTooltipsToJSONTyped(json, false);
}

export function IntegrationEventTooltipsToJSONTyped(value?: IntegrationEventTooltips | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actions': IntegrationEventTooltipsActionsToJSON(value['actions']),
        'resident': IntegrationEventTooltipsResidentToJSON(value['resident']),
        'pcc_update': IntegrationEventTooltipsResidentToJSON(value['pcc_update']),
    };
}

